import { render, staticRenderFns } from "./Inside.vue?vue&type=template&id=61d8b166&scoped=true"
import script from "./Inside.vue?vue&type=script&lang=js"
export * from "./Inside.vue?vue&type=script&lang=js"
import style0 from "./Inside.vue?vue&type=style&index=0&id=61d8b166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8b166",
  null
  
)

export default component.exports